module.exports = __webpack_public_path__ + "img/guessMovie.418f5b16.gif";